var pym = require("./lib/pym");
var pymChild;
require("./lib/webfonts");

// build our custom D3 object
var d3 = {
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

var { COLORS, classify } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");


// var renderD3Graphic = require("./renderD3Graphic");

// // Initialize the graphic.
// var render = function() {
//   // Render the chart!
//   var container = "#d3-graphic";
//   var element = document.querySelector(container);
//   var width = element.offsetWidth;
//   renderD3Graphic({
//     container,
//     width
//   });

//   // Update iframe
//   if (pymChild) {
//     pymChild.sendHeight();
//   }
// };

// Global config
var GRAPHIC_DEFAULT_WIDTH = 730;
var MOBILE_THRESHOLD = 500;
var MAP_TEMPLATE_ID = '#map-template';

// Global vars
var pymChild = null;
var isMobile = false;
var graphicData = null;

/*
 * Initialize the graphic.
 */
var onWindowLoaded = function() {
  render();

  window.addEventListener("resize", () => render());

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
}

/*
 * Render the graphic(s). Called by pym with the container width.
 */
var render = function(containerWidth) {
    if (!containerWidth) {
        containerWidth = GRAPHIC_DEFAULT_WIDTH;
    }

    if (containerWidth <= MOBILE_THRESHOLD) {
        isMobile = true;
    } else {
        isMobile = false;
    }

    // Render the maps!
    renderStateGridMap({
        container: '#before .map',
        width: containerWidth,
        data: BEFORE_DATA,
        categories: [
            'Banned by state law<sup>1, 2, 3</sup>',
            'Legal by federal court ruling<sup>4</sup>',
            'Legal by state action<sup>5</sup>'
        ],
        colors: [
            COLORS.yellow3,
            '#4794c2',
            COLORS.blue1,
        ]
    });

    renderStateGridMap({
        container: '#outcome .map',
        width: containerWidth,
        data: OUTCOME_DATA,
        categories: [
            'Becomes legal by Supreme Court decision',
            'Remains legal by previous lower federal court ruling',
            'Remains legal by state action<sup>5</sup>'
        ],
        colors: [
            COLORS.blue4,
            '#4794c2',
            COLORS.blue1
        ]
    });

    // Update iframe
    if (pymChild) {
        pymChild.sendHeight();
    }
}


/*
 * Render a state grid map.
 */
var renderStateGridMap = function(config) {
    // Clear existing graphic (for redraw)
    var containerElement = d3.select(config['container']);
    containerElement.html('');

    // Copy map template
    var template = d3.select(MAP_TEMPLATE_ID);
    containerElement.html(template.html());

    // Define color scale
    var colorScale = d3.scaleOrdinal()
        .domain(config.categories)
        .range(config.colors);

    // Create legend
    var legendElement = containerElement.select('.key');

    colorScale.domain().forEach(function(key, i) {
        var keyItem = legendElement.append('li')
            .classed('key-item', true)

        keyItem.append('b')
            .style('background', colorScale(key));

        keyItem.append('label')
            .html(key);
    });

    // Select SVG element
    var chartElement = containerElement.select('svg');

    // Set state colors
    config['data'].forEach(function(state) {
      if (state['category'] !== null) {
        var stateClass = 'state-' + classify(state['state_name']);

        chartElement.select('.' + stateClass)
          .attr('class', stateClass + ' state-active')
          .attr('fill', colorScale(state['category']));
      }
    });

    // Draw state labels
    chartElement.append('g')
        .selectAll('text')
            .data(config['data'])
        .enter().append('text')
            .attr('text-anchor', 'middle')
            .text(function(d) {
              var state = null;

              STATES.forEach(function(s) {
                if (s.name == d.state_name) {
                  state =  s.usps;
                }
              });

              return state;
            })
            .attr('class', function(d) {
                var cls = 'label';

                if (d['category'] !== null) {
                    cls += ' label-active';
                }

                if (d['category'] == 'Legal status unclear, but out-of-state marriages are recognized' ||
                    d['category'] == 'Legal status unclear') {
                    cls += ' invert'
                }

                return cls;
            })
            .attr('x', function(d) {
                var className = '.state-' + classify(d['state_name']);
                var tileBox = chartElement.select(className)["_groups"][0][0].getBBox();

                return tileBox['x'] + tileBox['width'] * 0.52;
            })
            .attr('y', function(d) {
                var className = '.state-' + classify(d['state_name']);
                var tileBox = chartElement.select(className)["_groups"][0][0].getBBox();
                var textBox = d3.select(this)["_groups"][0][0].getBBox();
                var textOffset = textBox['height'] / 2;

                return (tileBox['y'] + tileBox['height'] * 0.5) + textOffset - 1;
            });
}


// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);